/**
 * @author Rajan Grover
 * */

export class AppConstants {
  /**
   * Keys for Local Storage Types
   */
  static LocalStorageKeys = {
    AUTH_TOKEN: 'token',
    IMPERSONATE_TOKEN: 'impersonate',
    LOCALE: 'locale',
  };
}

/**
 * Keys for Table Component
 */
export enum TableColumnType {
  TEXT = 'TEXT',
  TOGGLE = 'TOGGLE',
  CHECKBOX = 'CHECKBOX',
  DROPDOWN = 'DROPDOWN',
  PICTURE = 'PICTURE',
  ACTIONS = 'ACTIONS',
  COLOR = 'COLOR'
}

/**
 * Keys for Button Component: Type
 */
export enum AppButtonType {
  PRIMARY = 'primary', // Primary color "Solid" button
  SECONDARY = 'secondary', // Secondary color "Outline" button
  OUTLINE = 'outline', // Primary color "Outline" button
  OUTLINE_SECONDARY = 'outline-secondary', // Secondary color "Outline" button
  OUTLINE_ERROR = 'outline-error', // Error color "Outline" button
  TEXT = 'text', // Primary color "Text" button
  TEXT_SECONDARY = 'text-secondary', // Secondary color "Text" button
  TEXT_UNDERLINE = 'text-underline', // Primary color "Text Underline" button
  TEXT_SECONDARY_UNDERLINE = 'text-secondary-underline', // Secondary color "Text Underline" button
  ERROR = 'error', // Error color "Solid" button
}

/**
 * Keys for Alert Position
 */
export enum AlertPosition {
  TOP_RIGHT = 'top-right',
  TOP_LEFT = 'top-left',
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_LEFT = 'bottom-left',
  CENTER = 'center',
  CENTER_TOP = 'center-top',
  BOTTOM_CENTER = 'bottom-center',
  CENTER_BOTTOM = 'center-bottom',
}

/**
 * Keys for Alert Types
 */
export enum AlertType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  CUSTOM = 'custom'
}

